import {
  GET_OUTSIDE_ANNUAL_PURCHASE_PLAN,
  GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_ERROR,
  GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_SUCCESS,
  GET_ENCRYPT_PURCHASE_ORDER,
  GET_ENCRYPT_PURCHASE_ORDER_ERROR,
  GET_ENCRYPT_PURCHASE_ORDER_SUCCESS
} from './OutsideAnnualPurchasePlanSection.actions'

const outsideAnnualPurchasePlanState = {
  error: undefined,
  loading: true,
  hasData: false,
  dni: '',
  gridData: [],
  excelData: [],
  year: '',
  publicationDate: '',
  encrypt: '',
  loadingSpinner: false,
  errorEncrypt: undefined,
  page: 1,
  records: 0,
  total: 1
}

/**
 * The Outside Annual Purchase Plan reducer.
 */

const outsideAnnualPurchasePlanReducer = (state = outsideAnnualPurchasePlanState, { payload, type }) => {
  switch (type) {
    case GET_OUTSIDE_ANNUAL_PURCHASE_PLAN: {
      return { ...state, loading: true }
    }
    case GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_SUCCESS: {
      return {
        ...state,
        loading: false,
        hasData: payload.hasData,
        year: payload.year,
        publicationDate: payload.publicationDate,
        gridData: payload.gridData,
        excelData: payload.excelData,
        page: payload.page,
        records: payload.records,
        total: payload.total
      }
    }
    case GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_ERROR: {
      return { ...state, loading: false, dni: payload.dni, error: payload.error }
    }

    case GET_ENCRYPT_PURCHASE_ORDER: {
      return { ...state, loadingSpinner: true }
    }
    case GET_ENCRYPT_PURCHASE_ORDER_SUCCESS: {
      return { ...state, loadingSpinner: false, encrypt: payload.encrypt }
    }
    case GET_ENCRYPT_PURCHASE_ORDER_ERROR: {
      return { ...state, loadingSpinner: false, errorEncrypt: payload.error }
    }
    default: {
      return state
    }
  }
}

export default outsideAnnualPurchasePlanReducer
